import {TextToolTip} from "components";
import {
    currentLegStatusData,
    currentLegTypeData,
    EscortAppPatientList,
    EscortAppPatientStatuses,
    LegTypesEnum,
    RateTypesForTable,
    TripTypesEnum
} from "fragments";
import {Svg} from 'assets'
import {dontAllowChangesLegStatuses, renderName} from "utils";
import {AssignVehicle} from "./fragments/assignVehicle";
import {TimeForTable} from "../../components/inputs/timeForTable";
import {TableHeaderVehicle} from "./fragments";
import moment from "moment/moment";

export const weeks = [
    {
        name: 'Sun',
    },

    {
        name: 'Mon',
    },

    {
        name: 'Tue',
    },

    {
        name: 'Wed',
    },

    {
        name: 'Thu',
    },

    {
        name: 'Fri',
    },

    {
        name: 'Sat',
    },
]

export const FilterTypeSlideEnum = {
    NEXT: 'NEXT',
    PREVIOUS: 'PREVIOUS'
}

export const ModesEnum = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY'
}


export const renderSelectTrip = [
    {
        tripDetails: {
            tripType: TripTypesEnum.APPOINTMENT,
            includeLegTypes: [LegTypesEnum.APPOINTMENT, LegTypesEnum.RETURN, LegTypesEnum.ESCORT_PICKUP, LegTypesEnum.ESCORT_DROPOFF],
            defaultLeg: [
                {
                    vehicle: null,
                    type: LegTypesEnum.APPOINTMENT,
                    scheduledTime: null,
                    arrivedTime: null,
                    pickupTime: null,
                    pickupMileage: null,
                    dropOffTime: null,
                    dropOffMileage: null,
                    apptTime: null,
                    pickupAddress: {
                        formattedAddress: null
                    },
                    dropOffAddress: {
                        formattedAddress: null
                    },
                },

                {
                    vehicle: null,
                    type: LegTypesEnum.RETURN,
                    scheduledTime: null,
                    arrivedTime: null,
                    pickupTime: null,
                    pickupMileage: null,
                    dropOffTime: null,
                    dropOffMileage: null,
                    apptTime: null,
                    pickupAddress: {
                        formattedAddress: null
                    },
                    dropOffAddress: {
                        formattedAddress: null
                    },
                },
            ]
        },
        title: 'Appointment',
        Icon: <Svg.HospitalSvg/>,
        iconBackground: '#E4F6FF',
    },

    {
        tripDetails: {
            tripType: TripTypesEnum.MED_DROP,
            includeLegTypes: [LegTypesEnum.MED_DROP, LegTypesEnum.MED_DROP_RETURN],
            defaultLeg: [
                {
                    vehicle: null,
                    type: LegTypesEnum.MED_DROP,
                    phone: null,
                    scheduledTime: null,
                    arrivedTime: null,
                    pickupTime: null,
                    pickupMileage: null,
                    dropOffTime: null,
                    dropOffMileage: null,
                    apptTime: null,
                    pickupAddress: {
                        formattedAddress: null
                    },
                    dropOffAddress: {
                        formattedAddress: null
                    },
                },

                {
                    vehicle: null,
                    type: LegTypesEnum.MED_DROP_RETURN,
                    phone: null,
                    scheduledTime: null,
                    arrivedTime: null,
                    pickupTime: null,
                    pickupMileage: null,
                    dropOffTime: null,
                    dropOffMileage: null,
                    apptTime: null,
                    pickupAddress: {
                        formattedAddress: null
                    },
                    dropOffAddress: {
                        formattedAddress: null
                    },
                },
            ]
        },
        title: 'Medication Drop',
        Icon: <Svg.MedicationDropSvg/>,
        iconBackground: '#F4EBFF',
    },

    {
        tripDetails: {
            tripType: TripTypesEnum.BUS_ROUTE,
            includeLegTypes: [LegTypesEnum.BUS_ROUTE, LegTypesEnum.BUS_ROUTE],
            defaultLeg: [
                {
                    vehicle: null,
                    type: LegTypesEnum.BUS_ROUTE,
                    phone: null,
                    scheduledTime: null,
                    arrivedTime: null,
                    pickupTime: null,
                    pickupMileage: null,
                    dropOffTime: null,
                    dropOffMileage: null,
                    apptTime: null,
                    pickupAddress: {
                        formattedAddress: null
                    },
                    dropOffAddress: {
                        formattedAddress: null
                    },
                },

                {
                    vehicle: null,
                    type: LegTypesEnum.BUS_ROUTE_RETURN,
                    phone: null,
                    scheduledTime: null,
                    arrivedTime: null,
                    pickupTime: null,
                    pickupMileage: null,
                    dropOffTime: null,
                    dropOffMileage: null,
                    apptTime: null,
                    pickupAddress: {
                        formattedAddress: null
                    },
                    dropOffAddress: {
                        formattedAddress: null
                    },
                }
            ]
        },
        title: 'Bus Route',
        Icon: <Svg.BusRouteSvg/>,
        iconBackground: '#DDEBFF',
    },
]

export const renderLeg = (type) => {
    switch (type) {
        case LegTypesEnum.MED_DROP: {
            return {
                Icon: <Svg.MedicationDropSvg/>,
                iconBackground: '#F4EBFF',
                title: 'Medication Drop',
            }
        }

        case LegTypesEnum.MED_DROP_RETURN: {
            return {
                Icon: <Svg.MedicationDropReturnSvg/>,
                iconBackground: '#F4EBFF',
                title: 'Medication Run',
            }
        }

        case LegTypesEnum.BUS_ROUTE: {
            return {
                Icon: <Svg.BusRouteSvg/>,
                iconBackground: '#F5F9FE',
                title: 'Bus Route',
            }
        }

        case LegTypesEnum.BUS_ROUTE_RETURN: {
            return {
                Icon: <Svg.BusRouteReturnSvg/>,
                iconBackground: '#F5F9FE',
                title: 'Bus Route Return',
            }
        }

        case LegTypesEnum.ESCORT_PICKUP: {
            return {
                Icon: <Svg.EscortPickupSvg/>,
                iconBackground: 'rgba(232, 236, 255, 0.99',
                title: 'Escort Pickup',
            }
        }

        case LegTypesEnum.RETURN: {
            return {
                Icon: <Svg.HouseSvg/>,
                iconBackground: '#D4FFEE',
                title: 'Patient Return',
            }
        }

        case LegTypesEnum.ESCORT_DROPOFF: {
            return {
                Icon: <Svg.EscortDropOfSvg style={{marginTop: 5}}/>,
                iconBackground: 'rgba(255, 193, 7, 0.10)',
                title: 'Escort Drop Off',
            }
        }
        default: {
            return {
                Icon: <Svg.HospitalSvg/>,
                iconBackground: '#E4F6FF',
                title: 'Appointment'
            }
        }
    }
}

export const dispatchBoardHead = () => {
    return [
        {
            title: "#",
            custom: false,
            minWidth: 50,
            width: 50
        },

        {
            title: "TP",
            custom: false,
            minWidth: 60,
            width: 60
        },

        {title: "MLS", name: 'distance', minWidth: 56, width: 56},

        {title: "LOS", name: 'patient.los', minWidth: 58, width: 58},
        {
            title: "Status",
            name: 'statuses',
            filterList: EscortAppPatientList,
            multiple: true,
            minWidth: 118,
            width: 118

        },
        {
            title: "VH",
            name: 'vehicle',
            rowName: 'unitNumber',
            ComponentView: TableHeaderVehicle,
            width: 80,
            minWidth: 80,
        },
        {title: "Patient", name: 'patient', rowName: 'firstName', minWidth: 200, width: '100%'},

        {
            title: "PU Time",
            disabled: true,
            name: 'pickUp.scheduledTime',
            minWidth: 110,
            width: 110
        },
        {
            title: "Appt Time",
            disabled: true,
            name: 'dropOff.scheduledTime',
            minWidth: 110,
            width: 110
        },
        {
            title: "Pickup",
            disabled: true,
            name: 'pickUp.pickupTime',
            minWidth: 110,
            width: '100%'
        },
        {
            title: "Dropped",
            disabled: true,
            name: 'dropOff.arrivedTime',
            minWidth: 110,
            width: 110
        },
        {
            title: "Payor",
            name: 'payer',
            rowName: 'name',
            minWidth: 104, width: '100%'
        },
        {
            title: "Origin",
            name: "pickUp.address.street",
            minWidth: 197,
            width: '100%'
        },
        {
            title: "City",
            name: "pickUp.address.city",
            minWidth: 81,
            width: '100%'
        },
        {
            title: "Zip",
            name: "pickUp.address.zip",
            minWidth: 66,
            width: '100%'
        },
        {
            title: "Dest.",
            name: "dropOff.address.street",
            minWidth: 164,
            width: '100%'
        },
        {
            title: "City",
            name: "dropOff.address.city",
            minWidth: 81,
            width: '100%'
        },
        {
            title: "Zip",
            name: "dropOff.address.zip",
            minWidth: 66,
            width: '100%'
        },
    ];
};

export const dispatchBoarBody = ({onChangeTimes, requestParams}) => {
    return [
        {
            rowText: (item, index) => {
                return (
                    <TextToolTip
                        showTooltip
                        arrow
                        text={`${index + 1}`}
                        content={`${index + 1}`}
                        textStyles={{
                            width: 'fit-content',
                        }}
                        wrapperStyles={{
                            width: 'fit-content',
                            margin: 'auto',
                            display: 'flex',
                        }}
                    />
                )
            },
            width: 50,
            minWidth: 50,
        },

        {
            rowText: (item) => (
                <TextToolTip
                    showTooltip
                    arrow
                    text={item?.type ? currentLegTypeData[item?.type].svg : ''}
                    content={item?.type ? currentLegTypeData[item?.type].textTooltip : ''}
                    textStyles={{
                        width: 'fit-content',
                        display: 'flex',
                    }}
                    wrapperStyles={{
                        width: 'fit-content',
                        margin: 'auto',
                        display: 'flex',
                    }}
                />
            ),
            width: 60,
            minWidth: 60,
            styles: {padding: 0}
            ,
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={`${item?.distance || item?.distance === 0 ? Number(item?.distance.toFixed(2)) : ''}`}
                    content={`${item?.distance || item?.distance === 0 ? Number(item?.distance.toFixed(2)) : ''}`}
                />
            ),
            width: 56,
            minWidth: 56,
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={RateTypesForTable[item?.patient?.los]}
                    content={RateTypesForTable[item?.patient?.los]}
                    wrapperStyles={{
                        width: 'fit-content',
                        margin: 'auto',
                    }}
                />
            ),
            width: 58,
            minWidth: 58,
        },

        {
            rowText: (item) => (
                <div className='flex-all-center' style={{gap: 4}}>
                    <TextToolTip
                        classNameWrapper='dispatch-board-table-statuses-wrapper'
                        text={EscortAppPatientStatuses[item?.status]}
                        content={EscortAppPatientStatuses[item?.status]}
                        wrapperStyles={{
                            width: 'fit-content',
                            background: item?.status ? currentLegStatusData?.[item?.status]?.backgroundColor : '',
                        }}
                        textStyles={{
                            width: 'fit-content',
                            color: item?.status ? currentLegStatusData?.[item?.status]?.color : ''
                        }}
                    />
                    {item?.isDuplicate &&
                        <TextToolTip
                            content='This trip appears to be a duplicate (same patient, date, origin, and destination)'
                            text={<Svg.CopySvg/>}
                            arrow
                            placement='right'
                            showTooltip
                            textStyles={{
                                display: 'flex',
                            }}
                            wrapperStyles={{
                                width: 'fit-content',
                            }}
                        />
                    }


                    {/*{(howMuchIsLeft(item?.pickUp?.scheduledTime) === 0 && (item?.status === EscortAppPatientEnum.OPEN || item?.status === EscortAppPatientEnum.ASSIGNED)) &&*/}
                    {/*    <div style={{*/}
                    {/*        minWidth: 26,*/}
                    {/*        minHeight: 26,*/}
                    {/*        width: 26,*/}
                    {/*        height: 26,*/}
                    {/*        borderRadius: '50%',*/}
                    {/*        background: '#FEF2F2',*/}
                    {/*        padding: 5*/}
                    {/*    }}>*/}
                    {/*        <Svg.ClockSvg style={{width: '100%', height: '100%'}}/>*/}
                    {/*    </div>*/}
                    {/*}*/}
                </div>
            ),
            width: 118,
            minWidth: 118,
        },

        {
            rowText: (item) => (
                <AssignVehicle
                    item={item}
                    requestParams={requestParams}
                />
            ),
            minWidth: '80px',
            styles: {padding: 0, border: `none`}
        },

        {
            rowText: (item) => {
                return (
                    <TextToolTip
                        text={renderName(item?.patient)}
                        content={renderName(item?.patient)}
                    />
                )
            }, minWidth: '200px',
        },

        {
            rowText: (item) => {
                return (
                    <div
                        className='screen-full-width'
                        style={dontAllowChangesLegStatuses(item?.status) ? {
                            pointerEvents: 'none',
                            opacity: .7
                        } : {}}
                    >
                        <TimeForTable
                            classNameWrapper='time-input-table-wrapper'
                            onChange={(value) => onChangeTimes(item, value, 'pickUp', 'scheduledTime')}
                            name={`scheduledTime`}
                            defaultValue={item?.pickUp?.scheduledTime}
                        />
                    </div>
                )
            },
            width: 110,
            minWidth: 110,
        },

        {
            rowText: (item) => {
                return (
                    <div
                        className='screen-full-width'
                        style={dontAllowChangesLegStatuses(item?.status) ? {
                            pointerEvents: 'none',
                            opacity: .7
                        } : {}}
                    >
                        {(item?.type === LegTypesEnum.APPOINTMENT || item?.type === LegTypesEnum.MED_DROP || item?.type === LegTypesEnum.BUS_ROUTE) ?
                            <TimeForTable
                                classNameWrapper='time-input-table-wrapper'
                                onChange={(value) => onChangeTimes(item, value, 'dropOff', 'scheduledTime')}
                                name={`apptTime`}
                                defaultValue={item?.dropOff?.scheduledTime}
                            />
                            :

                            <TextToolTip
                                text={'---'}
                                content={'---'}
                            />
                        }
                    </div>
                )
            },
            width: 110,
            minWidth: 110,
        },

        {
            rowText: (item) => (
                <div
                    className='screen-full-width'
                    style={dontAllowChangesLegStatuses(item?.status) ? {
                        pointerEvents: 'none',
                        opacity: .7
                    } : {}}
                >
                    <TimeForTable
                        classNameWrapper='time-input-table-wrapper'
                        onChange={(value) => onChangeTimes(item, value, 'pickUp', 'pickupTime')}
                        name={`pickupTime`}
                        defaultValue={item?.pickUp?.pickupTime}
                        maxTime={moment(item?.pickUp?.arrivedTime).format('HH:mm')}
                        allowClearBtn={!item?.dropOff?.arrivedTime}
                        disabled={!item?.pickUp?.arrivedTime}
                    />
                </div>
            ),
            width: 110,
            minWidth: 110,
        },

        {
            rowText: (item) => (
                <div
                    className='screen-full-width'
                    style={dontAllowChangesLegStatuses(item?.status) ? {
                        pointerEvents: 'none',
                        opacity: .7
                    } : {}}
                >
                    <TimeForTable
                        classNameWrapper='time-input-table-wrapper'
                        onChange={(value) => onChangeTimes(item, value, 'dropOff', 'arrivedTime')}
                        name={`dropOffTime`}
                        defaultValue={item?.dropOff?.arrivedTime}
                        minTime={moment(item?.pickUp?.pickupTime).format('HH:mm')}
                        disabled={!item?.pickUp?.pickupTime}
                        allowClearBtn
                    />
                </div>
            ),
            width: 110,
            minWidth: 110,
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.payer?.name}
                    content={item?.payer?.name}
                />
            ), minWidth: '104px',
        },
        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.pickUp?.address?.street}
                    content={item?.dropOff?.address?.street}
                />
            ), minWidth: '197px',
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.pickUp?.address?.city}
                    content={item?.pickUp?.address?.city}
                />
            ), minWidth: '81px',
        },
        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.pickUp?.address?.zip}
                    content={item?.pickUp?.address?.zip}
                />
            ), minWidth: '66px',
        },
        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.dropOff?.address?.street}
                    content={item?.dropOff?.address?.street}
                />
            ), minWidth: '164px',
        },

        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.dropOff?.address?.city}
                    content={item?.dropOff?.address?.city}
                />
            ), minWidth: '81px',
        },
        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.dropOff?.address?.zip}
                    content={item?.dropOff?.address?.zip}
                />
            ), minWidth: '66px',
        },
    ];
};


export const idleVehiclesHead = () => {
    return [
        {title: "Unit", custom: false, width: "80px"},
        {title: "Make", custom: false},
        {title: "Model", custom: false},
        {title: "Year", custom: false},
        {title: "Type", custom: false},
    ];
};

export const idleVehiclesBody = () => {
    return [
        {
            rowText: (item) => (
                <TextToolTip
                    text={`#${item?.unitNumber}`}
                    content={`#${item?.unitNumber}`}
                />
            ),
        },
        {
            rowText: (item) => <TextToolTip text={item?.make} content={item?.make}/>,
        },
        {
            rowText: (item) => (
                <TextToolTip text={item?.modelName} content={item?.modelName}/>
            ),
        },
        {
            rowText: (item) => (
                <TextToolTip
                    text={item?.year}
                    content={item?.year}
                    dateRow
                    format="YYYY"
                />
            ),
        },

        {
            rowText: (item) => <TextToolTip text={item?.type} content={item?.type}/>,
        },
    ];
};

export const emptyState = (addTrip) => {
    return {
        emptyBtnText: 'Add Trip',
        notTitleText: 'No trips created yet',
        notDescText: 'Create your first trip to begin scheduling transportation for patients.',
        EmptySvg: Svg.EmptyTrips,
        clickToEmptyAddButton: addTrip,
    }
}
export const dispatchBoardCsv = {
    path: '/legs/export/csv',
    status: true,
}